<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="User"
        :baseView="baseView"
        primaryLabel="User"
        :secondaryLabel="baseView.id"
      />
    </template>

    <DxToolbar class="view-toolbar">
      <DxItem #default location="before" locate-in-menu="never">
        <div class="toolbar-label">
          <div v-if="baseView.mode == 'review' || baseView.mode == 'edit'">
            <b>{{ model.User.Name }}</b>
          </div>
        </div>
      </DxItem>
      <DxItem
        :options="toolbar.edit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
      />
      <DxItem
        :options="toolbar.save"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode != 'review'"
      />
    </DxToolbar>

    <div class="view-card responsive-paddings" id="userPanel">
      <form v-if="loadingCompleted">
        <DxForm
          :form-data.sync="model"
          :read-only="false"
          :show-colon-after-label="false"
          :show-required-mark="false"
          :show-validation-summary="false"
          :validation-group="formsConfig.validationGroup"
          :col-count-by-screen="colCountByScreen"
          label-location="left"
          :customizeItem="customizeItem"
          :items="items"
          ref="userForm"
          cssClass="cssClass"
        >
          <!-- SelectBox Template  -->
          <!-- <template #agentTemplate="{data}">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary">{{data.DisplayName}}</span>
              <span class="auto-complete-secondary">{{data.Code}}</span>
            </div>
          </template>-->
        </DxForm>
      </form>
    </div>
  </gc-main-layout>
</template>

<script>
import validationEngine from "devextreme/ui/validation_engine";
import { FeatureStorage, secureStorage } from "../../../_services/storage";
import BaseViewMixin from "../../../v1/_mixins/base.view";
import { UserService } from "../../../_services/api/settings/user/user.service";

var UserTypeDataSource = [];
var RoleDataSource = [];

export default {
  props: {},
  mixins: [BaseViewMixin],
  watch: {
    $route: {
      immediate: true,
      handler: "requestApplicationTypes",
    },
  },
  updated() {
    if (this.loadingCompleted && this.formsConfig.validationGroup)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  components: {},
  data() {
    return {
      isAdminUser: false,
      isUserExistInLegacy: false,
      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/user/edit/${this.model.User.Name}`,
            });
          },
          // visible : this.formsConfig.editableOption
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: async (e) => {
            this.$logger.trackEventButtonClickSave();
            const result = await e.validationGroup.validate();
            if (result.isValid) {
              this.showLoading(true);
              var ApplicationUserManagement = {
                ApplicationUserCode: this.model.User.Name,
                ApplicationUserTypeCode: this.model.User.Type,
                Inactive: this.model.User.Status,
                UseExistingApplicationUserTypeCode: "",
              };
              var payload = {
                Mode: this.baseView.mode,
                ActiveInstanceCount: 0,
                DateInto: new Date(),
                Username: this.model.User.Name,
                FirstName: this.model.User.FirstName,
                LastName: this.model.User.LastName,
                Password: this.model.User.Password,
                Email: this.model.User.Email,
                Template: this.model.User.Template,
                Inactive: this.model.User.Status,
                ApplicationUserManagement,
                UserSetting: {
                  BranchAccess: "All",
                  CompanyAccess: "All",
                  DivisionAccess: "All",
                  UpdateBOMStdCost: false,
                  UpdateBOMTStdCost: false,
                  IsCrmManager: false,
                },
              };

              this.saveUserDetails(payload);
            } else {
              // this.displayValidationSummary();

              this.addErrorMessagesFromValidationResult(result);
              this.displayValidationSummary();
              validationEngine.validateGroup(this.formsConfig.validationGroup);
            }
          },
        },
      },
      colCountByScreen: {
        xs: 1,
        sm: 1,
        md: 1,
        lg: 1,
      },
      model: {
        isUserExistInLegacy: false,
        User: {
          Name: "",
          FirstName: "",
          LastName: "",
          Password: "",
          Email: "",
          Template: "",
          Status: "Active",
          Type: "",
          TypeCode: null,
          RoleIds: [],
        },
        userTypes: [],
      },

      items: [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              dataField: "User.Name",
              editorOptions: {
                editorType: "dxTextBox",
                inputAttr: { autocomplete: "new-password" },
                onValueChanged: async ({ value }) => {
                  if (
                    !value ||
                    !value.trim() ||
                    this.baseView.mode !== "create"
                  )
                    return;
                  this.showLoading(true);
                  await UserService.getUserByUsernameAndValidateCxUser(value)
                    .then(({ data }) => {
                      this.setFeildValues(data);
                      this.showLoading(false);
                    })
                    .catch((err) => {
                      this.displayServerError(err, "User Already exist");
                      this.showLoading(false);
                    });
                },
                // readOnly: this.baseView.mode === "edit",
              },
              label: {
                text: "User Name",
              },
              validationRules: [
                {
                  type: "required",
                  message: "User Name is required",
                },
              ],
            },
            {
              dataField: "User.Email",
              editorOptions: {
                editorType: "dxTextBox",
                maxLength: 200,
                readOnly: this.isUserExistInLegacy,
              },
              label: {
                text: "Email",
              },
              validationRules: [
                {
                  type: "email",
                  message: "Invalid Email Address",
                },
              ],
            },
            {
              dataField: "User.Status",
              id: "status-selectBox",
              validationRules: [
                {
                  type: "required",
                  message: "User Status is required",
                },
              ],
              editorType: "dxSelectBox",
              editorOptions: {
                items: [
                  {
                    value: "N",
                    text: "Active",
                  },
                  {
                    value: "Y",
                    text: "Inactive",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
              label: {
                text: "Status",
              },
            },
            {
              dataField: "User.FirstName",
              editorOptions: {
                maxLength: 50,
                editorType: "dxTextBox",
                readOnly: this.isUserExistInLegacy,
              },
              label: {
                text: "First Name",
              },
              // validationRules: [
              //   {
              //     type: "required",
              //     message: "First Name is required",
              //   },
              // ],
            },
            {
              dataField: "User.LastName",
              editorOptions: {
                readOnly: this.isUserExistInLegacy,
                editorType: "dxTextBox",
                maxLength: 50,
              },
              label: {
                text: "Last Name",
              },
              // validationRules: [
              //   {
              //     type: "required",
              //     message: "Last Name is required",
              //   },
              // ],
            },
            {
              dataField: "User.Password",
              editorOptions: {
                mode: "password",
                editorType: "dxTextBox",
                maxLength: 50,
                inputAttr: { autocomplete: "new-password" },
              },
              // visible: !(
              //   // this.isUserExistInLegacy || this.baseView.mode !== "create"
              // ),
              validationRules: [],
              label: {
                text: "Password",
              },
            },
            {
              dataField: "User.Type",
              id: "user-type-selectBox",
              caption: "License Type",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: UserService.dataSourceConfig({
                  url: "api/ApplicationUserType",
                  filter: "Inactive eq 'N'",
                  select: ["Code", "DisplayName"],
                  orderby: "Sequence asc, Code asc",
                }),
                valueExpr: "Code",
                displayExpr: "DisplayName",
                searchExpr: ["Code", "DisplayName"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                onValueChanged: ({ value }) => {
                  this.model.User.RoleIds = [];
                  this.loadRolesByLicenseType(value);
                },
              },
              label: {
                text: "License Type",
              },
              validationRules: [
                {
                  type: "required",
                  message: "License Type is required",
                },
                {
                  type: "async",
                  validationCallback: this.userTypeExistsRuleCallback,
                  message: "License Type does not exist",
                },
              ],
            },
            {
              dataField: "User.RoleIds",
              editorType: "dxTagBox",
              editorOptions: {
                items: [],
                valueExpr: "RoleId",
                displayExpr: "RoleName",
                searchEnabled: true,
                stylingMode: "underlined",
                placeholder: "Select roles...",
              },
              label: {
                text: "Roles",
              },
              validationRules: [
                {
                  type: "custom",
                  message: "At least one Role should be selected",
                  validationCallback: ({ value }) =>
                    Array.isArray(value) && value.length > 0,
                },
              ],
            },
          ],
        },
      ],
      position: { of: "#userPanel" },
      loadingVisible: true,
      showIndicator: true,
      shading: true,
      showPane: true,
      hideOnOutsideClick: false,
    };
  },
  methods: {
    setFeildValues(data) {
      if (data.value.length != 0) {
        this.model.User.FirstName = data.value[0].FirstName;
        this.model.User.LastName = data.value[0].Surname;
        this.model.User.Email = data.value[0].Email;
        this.model.User.Template = data.value[0].Template;
        this.model.User.Status = data.value[0].Inactive;
        // this.model.User.Type = "Standard";
        // var e = {
        //   itemData: {
        //     Code: "Standard",
        //   },
        // };
        // this.UserTypeChange(e);
        // this.items[0].items[6].editorOptions.readOnly =
        this.setIsUserExistInLegacy(true);
      } else {
        this.model.User.FirstName = "";
        this.model.User.LastName = "";
        this.model.User.Email = "";
        this.model.User.Template = "";
        this.setIsUserExistInLegacy(false);
      }
    },
    setIsUserExistInLegacy(value) {
      this.isUserExistInLegacy = value;
    },
    userTypeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        UserService.getUserTypeByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.User.TypeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    async saveUserDetails(payload) {
      await UserService.saveLegacyCxUser(payload)
        .then(async () => {
          await UserService.saveUserRoles(
            this.model.User.Name,
            this.model.User.RoleIds || [],
          ).catch((error) => {
            this.displayServerError(error, "Failed to save roles");
          });
          this.$notify("User saved successfully", "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/user/review/${this.model.User.Name}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "User saved Failed");
        });
    },
    setRoleItems(roles) {
      this.items[0].items[7].editorOptions.items = roles;
      if (this.$refs.userForm) {
        const editor = this.$refs.userForm.instance.getEditor("User.RoleIds");
        if (editor) editor.option("items", roles);
      }
    },
    async loadRolesByLicenseType(licenseType) {
      if (!licenseType) {
        this.setRoleItems([]);
        return;
      }
      await UserService.getRolesByLicenseType(licenseType)
        .then((response) => {
          this.setRoleItems(response.data.value || []);
        })
        .catch(() => {
          this.setRoleItems([]);
        });
    },
    async requestApplicationTypes() {
      this.showLoading(true);
      await UserService.getUserTypes()
        .then(async (response) => {
          UserTypeDataSource = response.data.value;

          this.$set(
            this.items[0].items[6].editorOptions,
            "dataSource",
            this.isAdminUser
              ? UserTypeDataSource.filter((x) => x.Code !== "Administrator")
              : UserTypeDataSource,
          );

          if (this.baseView.mode == "edit") {
            this.items[0].items[0].editorOptions.readOnly = true;
            this.items[0].items[5].editorOptions.readOnly =
              this.isAdminUser == false;
          } else if (this.baseView.mode == "create") {
            this.items[0].items[5].validationRules.push({
              type: "required",
              message: "Password is required",
            });
          }

          if (this.baseView.mode == "review" || this.baseView.mode == "edit") {
            await UserService.getUserTypeCode(this.baseView.id).then(
              (response) => {
                this.model.User.TypeCode =
                  response.data.value[0].ApplicationUserTypeCode;
                this.model.User.Status = response.data.value[0].Inactive;
                this.model.User.Type = UserTypeDataSource.find(
                  (x) => x.Code == this.model.User.TypeCode,
                ).DisplayName;
              },
            );
            this.model.User.Name = this.baseView.id;
            await Promise.all([
              UserService.getUserRoles(this.baseView.id).then((response) => {
                this.model.User.RoleIds = response.data || [];
              }),
              this.loadRolesByLicenseType(this.model.User.TypeCode),
            ]);
          } else {
            this.$set(
              this.items[0].items[6].editorOptions,
              "readOnly",
              !this.isAdminUser,
            );
            const defaultType = UserTypeDataSource.find(
              (x) => x.Code == "Standard",
            );
            if (defaultType) {
              this.model.User.Type = defaultType.DisplayName;
              this.model.User.TypeCode = defaultType.Code;
            }
            await this.loadRolesByLicenseType(this.model.User.TypeCode);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          // this.$logger.debug("error", error);
        });

      this.showLoading(false);
      this.loadingCompleted = true;
    },
    backButtonFunction() {
      this.$router.push({
        path: "/user",
      });
    },
  },
  mounted() {
    console.log(
      "Shiham >>> FeatureStorage.getUserType()",
      FeatureStorage.getUserType(),
    );
    // check logged user
    this.isAdminUser = (FeatureStorage.getUserType() || "").includes(
      "Administrator",
    );

    if (!this.isAdminUser) {
      this.isAdminUser = secureStorage.get("isAdmin");
    }

    this.items[0].items[6].editorOptions.readOnly = !this.isAdminUser;

    if (
      (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
      this.$refs["userForm"]
    ) {
      // this.items[0].items[0].visible = false;
      let form = this.$refs["userForm"].instance;
      form.repaint();
    }
  },
  async created() {
    this.toolbar.edit.visible = this.formsConfig.editableOption;
    if (this.baseView.mode !== "create") {
      var { data } = await UserService.getUserByUsername(this.baseView.id);

      this.model.User.Name = data.value[0].Username;
      this.model.User.FirstName = data.value[0].FirstName;
      this.model.User.LastName = data.value[0].LastName;
      this.model.User.Email = data.value[0].Email;
      this.model.User.Template = data.value[0].Template;
    }
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  computed: {
    setDataSource() {
      return UserTypeDataSource;
    },
  },
};
</script>

<style lang="scss"></style>
